const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

import MiniCart from './components/cart/MiniCart.jsx';

export const AppComponents = {
  MiniCart,
  // UI COMPONENTS ==============================================================
  Slider: asyncComponentFactory('ui/Slider'),
  Drawer: asyncComponentFactory('ui/Drawer'),
  Modal: asyncComponentFactory('ui/Modal'),
  Accordion: asyncComponentFactory('ui/Accordion'),
  CustomSelect: asyncComponentFactory('ui/CustomSelect'),
  Search: asyncComponentFactory('ui/Search'),
  ContaminantsLoop: asyncComponentFactory('ui/ContaminantsLoop'),
  // NAV COMPONENTS -----------------------------------------------------------
  StickyNav: asyncComponentFactory('nav/StickyNav'),
  // MEDIA COMPONENTS -----------------------------------------------------------
  MediaPlayer: asyncComponentFactory('media/MediaPlayer'),
  VideoTile: asyncComponentFactory('media/VideoTile'),
  // PRODUCT COMPONENTS -----------------------------------------------------------
  ProductForm: asyncComponentFactory('product/ProductForm'),
  ProductGallery: asyncComponentFactory('product/ProductGallery'),
  QuantitySelector: asyncComponentFactory('product/QuantitySelector'),
  AddToCart: asyncComponentFactory('product/AddToCart'),
  MiniProductForm: asyncComponentFactory('product/MiniProductForm'),
  StickyAtc: asyncComponentFactory('product/StickyAtc'),
};
